export default "__VITE_ASSET__CjI1d5u6__"